import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, useParams } from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import './login.css';
import Footer from '../../components/footer.js';

const BackgroundContainer = styled.div`
  background-color: azure;
  height: 95vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 2px solid #004aad;
  margin-bottom: 1%;
`;

const ResetContainer = styled.div`
  background-color: azure;
  border-radius: 15px;
  padding: 30px;
  width: 350px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background: linear-gradient(to right, #004aad, #00b7eb);
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
`;

const InputField = styled.input`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
`;

const AlertContainer = styled(motion.div)`
  position: absolute;
  top: -80px;
  left: 0;
  right: 0;
  background-color: ${props => props.isError ? '#ff4444' : '#28a745'};
  color: white;
  padding: 15px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
`;

const AlertContent = styled.div`
  display: flex;
  align-items: center;
`;

const AlertIcon = styled(motion.svg)`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 0 5px;
  &:hover {
    opacity: 0.8;
  }
`;

const ResetPasswordConfirm = () => {
  const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const { userId } = useParams();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/auth/reset-password/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          password: formData.password,
          confirmPassword: formData.confirmPassword 
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to reset password');
      }

      if (data.success) {
        setMessage(data.message);
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError(err.message || 'An error occurred. Please try again later.');
      console.error('Error resetting password:', err);
    }
  };

  const handleCloseAlert = () => {
    setMessage('');
    setError('');
  };

  return (
    <>
      <BackgroundContainer>
        <ResetContainer>
          <AnimatePresence>
            {(message || error) && (
              <AlertContainer
                isError={!!error}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <AlertContent>
                  <AlertIcon
                    viewBox="0 0 24 24"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    {error ? (
                      <path
                        fill="white"
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                      />
                    ) : (
                      <path
                        fill="white"
                        d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                      />
                    )}
                  </AlertIcon>
                  <p>{error || message}</p>
                </AlertContent>
                <CloseButton onClick={handleCloseAlert}>×</CloseButton>
              </AlertContainer>
            )}
          </AnimatePresence>
          <h2 style={{ color: "white", textAlign: "center", marginBottom: "20px" }}>
            Reset Your Password
          </h2>
          <form>
            <div>
              <label style={{ color: "white", display: "block", marginBottom: "5px" }}>
                New Password *
              </label>
              <InputField
                type="password"
                name="password"
                required
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter new password"
              />
            </div>
            <div>
              <label style={{ color: "white", display: "block", marginBottom: "5px" }}>
                Confirm Password *
              </label>
              <InputField
                type="password"
                name="confirmPassword"
                required
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm new password"
              />
            </div>
            <SubmitButton type="button" onClick={handleSubmit}>
              Reset Password
            </SubmitButton>
          </form>
          <div style={{ textAlign: "center", marginTop: "15px" }}>
            <Link to="/" style={{ color: "white", textDecoration: "none" }}>
              Back to Login
            </Link>
          </div>
        </ResetContainer>
      </BackgroundContainer>
      <Footer />
    </>
  );
};

export default ResetPasswordConfirm;